import { Component } from '@angular/core';

@Component({
  selector: 'app-trash-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './trash-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class TrashIconComponent { }
